import question from '@/api/question'
import { ValidationObserver, localize } from 'vee-validate'
import koreanDictionary from 'vee-validate/dist/locale/ko'
// import englishDictionary from 'vee-validate/dist/locale/en'

const koDictionary = Object.assign(koreanDictionary, {
  messages: {
    ...koreanDictionary.messages,
    email: '입력형식이 올바르지 않습니다.',
  }
})

export default {
  name: 'SupportForm',
  components: {
    ValidationObserver,
    inputForm: () => import('@/components/base/Input'),
    checkBox: () => import('@/components/base/CheckBox'),
  },
  watch: {
    '$route.params.locale' (lang) {
      localize(lang, koDictionary)
    }
  },
  data () {
    return {
      subject: '',
      media: '',
      name: '',
      offer: '',
      mail: '',
      textarea: '',
      file: '',
      attachFileId: null,
      agreeAll: false,
      agreePrivate: false,
      loading: false,
      fileLoading: false,
      fileError: ''
    }
  },
  methods: {
    emailCheck (v) {
      // eslint-disable-next-line
      const regex = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/
      return regex.test(v)
    },
    attachUpload (files) {
      if (typeof files !== 'object' || files.length <= 0) {
        this.file = ''
        this.attachFileId = null
        return
      }

      console.log(files[0].name.length)

      if (files[0].name.length > 100) {
        this.fileError = '파일 이름이 너무 깁니다.'
        this.file = ''
        return false
      }

      const maxSize = 30 * 1024 * 1024
      const fileSize = files[0].size
      if (fileSize > maxSize) {
        this.fileError = '첨부파일 사이즈는 30MB 이내로 등록 가능합니다.'
        this.file = ''
        return false
      } else {
        this.fileError = ''
        this.saveUpload(files).catch(e => {
          this.fileLoading = false
          this.file = ''
          this.attachFileId = null
          this.fileError = '업로드가 실패했습니다.'
        })
        return true
      }
    },
    async saveUpload (file) {
      this.fileLoading = true
      const formData = new FormData()
      formData.append('file', file[0])

      let mail = { }
      if (this.mail) {
        mail = {
          userEmail: this.mail
        }
      }

      const params = Object.assign({}, mail)

      const { data } = await question.saveUpload(formData, params)
      if (data) {
        this.attachFileId = data.body.data.fileId
        this.fileLoading = false

        this.$root.$emit('toast:show', {
          text: this.$t('question.attachFileUploaded')
        })
      }
    },
    async saveQuestion (options, moveRouteName) {
      if (!this.loading) {
        let name = 'Main'
        let message = '문의 접수가 완료되었습니다.'

        if (moveRouteName) {
          name = moveRouteName
          message = '상담/신고 접수가 완료되었습니다.'
        }

        this.loading = true

        let attachFileId = { }

        if (this.attachFileId) {
          attachFileId = {
            attachFileId: this.attachFileId
          }
        }
        const params = Object.assign({}, options, attachFileId)

        const { data } = await question.saveQuestion(params)

        if (data) {
          this.subject = ''
          this.media = ''
          this.name = ''
          this.offer = ''
          this.mail = ''
          this.textarea = ''
          this.file = ''
          this.agreeAll = false
          this.agreePrivate = false
          this.agreePrecautions = false
          this.attachFileId = null

          this.$refs.observer.reset()

          this.$alert.show({
            message: message
          }).$on('alert:close', () => {
            this.$router.push({ name: name })
          })
        } else {
          this.$alert.show({
            message: '문의하는데 실패했습니다. 오류가 계속되면 관리자에게 연락주세요'
          }).$on('alert:open', () => {})
        }

        this.loading = false
      }
    },
    onDeleteFile () {
      this.file = ''
      this.attachFileId = null
    }
  },
}
